module.exports = __webpack_public_path__ + "img/sample03.136a55c1.gif";